/* @jsx h */
import {
  defineComponent,
  ref,
  provide,
  inject,
  h,
  onMounted,
  type Ref,
  type App,
  type Slot,
} from "vue";
import { UserProfile } from "@app/types/index";
import { api } from "@app/data/api";

// Define the types for the AuthSession and context
export type AuthSession = {
  id: number;
  profile: UserProfile;
};

interface AuthContextType {
  user: Ref<AuthSession | null>;
  setUser: (user: AuthSession | null) => void;
}

// Keys for provide/inject
const AuthContextKey = Symbol("AuthContext");

// Provide Component
export const AuthProvider = defineComponent<{}>({
  setup(_, { slots }) {
    const user = ref<AuthSession | null>(null);
    const loaded = ref(false);

    const fetchData = async () => {
      //    const session = await api.getSession();
      //      if (session) user.value = session;
      loaded.value = true;
    };

    onMounted(() => {
      fetchData();
    });

    const setUser = (newUser: AuthSession | null) => {
      user.value = newUser;
    };

    provide(AuthContextKey, { user, setUser });

    // Render the children passed to AuthProvider
    return () => (loaded.value ? slots.default?.() : null);
  },
});

// Hook to use Auth
export function useAuth(): AuthContextType {
  const context = inject<AuthContextType>(AuthContextKey);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
